// src/components/Header.jsx
import React from 'react';
import { Link } from 'react-router-dom';
import Nav from './Nav';
import TypeWriter from './TypeWriter';
import '../assets/styles/Header.css'; // Adjust the path as necessary

const Header = () => (
  <header className="homepage-header">
    <TypeWriter />
    <section className="hero">
      <div className="hero-text">
        <h1 id="text">Build. Break. Secure.</h1>
      </div>
    </section>
    
    <h1 className="logo">
      <Link to="/" aria-label="logo">BobTheSkull</Link>
    </h1>
    <Nav />
  </header>
  
);

export default Header;